import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const WebChat = ({
  size,
  type,
  theme,
  className,
  dataTestId = "webchat-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2 6.133A4.534 4.534 0 0 0 10.667 1.6H5.334A4.534 4.534 0 0 0 .8 6.133v4.209a.8.8 0 0 0 1.6 0V6.133A2.934 2.934 0 0 1 5.334 3.2h5.333A2.934 2.934 0 0 1 13.6 6.133v2.243a2.934 2.934 0 0 1-2.933 2.934H3.954a.8.8 0 0 0-.557.226l-2.354 2.29a.8.8 0 1 0 1.115 1.147L4.28 12.91h6.388A4.534 4.534 0 0 0 15.2 8.376V6.133Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
